import { theme } from "../theme";
import RankioMark from "./RankioMark";

// ── Rankio logo = značka + nápis ──────────────────────────────────────────────
// `height` je výška celého loga, stejně jako u předchozí verze, takže se
// nikde nemění velikost ani umístění. Poměry nápisu jsou převzaté
// z původního lockupu (fontSize 26 a mezera 10 ve viewBoxu vysokém 48).
export default function RankioLogo({ height = 34, darkText = false, markOnly = false }) {
  if (markOnly) return <RankioMark height={height} />;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: height * 0.208, lineHeight: 1 }}>
      <RankioMark height={height} />
      <span style={{
        fontFamily: theme.font,
        fontWeight: 800,
        fontSize: height * 0.542,
        letterSpacing: "-0.038em",
        color: darkText ? "#fff" : theme.ink,
        whiteSpace: "nowrap",
      }}>
        rankio
      </span>
    </span>
  );
}
